import { render } from "./TemplateSheetEmergencyCode.vue?vue&type=template&id=97f8a716&scoped=true"
import script from "./TemplateSheetEmergencyCode.vue?vue&type=script&lang=js"
export * from "./TemplateSheetEmergencyCode.vue?vue&type=script&lang=js"

import "./TemplateSheetEmergencyCode.vue?vue&type=style&index=0&id=97f8a716&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-97f8a716"

export default script